import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ButtonsModule} from './components/atoms/buttons/buttons.module';
import {UiFormsModule} from './components/atoms/forms/ui-forms.module';
import {LinksModule} from './components/atoms/links/links.module';

import {AMessageComponent} from './components/atoms/a-message/a-message.component';
import {MDropdownListComponent} from './components/molecules/m-dropdown-list/m-dropdown-list.component';
import {SpacerComponent} from './components/spacer/spacer.component';
import {ATotalResultComponent} from './components/atoms/a-total-result/a-total-result.component';
import {ATitleLabelComponent} from './components/atoms/a-title-label/a-title-label.component';
import {ABadgeComponent} from './components/atoms/a-badge/a-badge.component';
import {AAvatarComponent} from './components/atoms/a-avatar/a-avatar.component';
import {AStatusComponent} from './components/atoms/a-status/a-status.component';
import {AMentionComponent} from './components/atoms/a-mention/a-mention.component';
import {AUnitLegendComponent} from './components/atoms/a-unit-legend/a-unit-legend.component';
import {ATabComponent} from './components/atoms/a-tab/a-tab.component';
import {MTabsComponent} from './components/molecules/m-tabs/m-tabs.component';
import {ADatePickerComponent} from './components/atoms/a-date-picker/a-date-picker.component';
import {DpDatePickerModule} from 'ng2-date-picker';
import {ASpinnerComponent} from './components/atoms/a-spinner/a-spinner.component';
import {AGaugeBarComponent} from './components/atoms/a-gauge-bar/a-gauge-bar.component';
import {AUnitComponent} from './components/atoms/a-unit/a-unit.component';
import {MStatsItemComponent} from './components/molecules/m-stats-item/m-stats-item.component';
import {ALabelComponent} from './components/atoms/a-label/a-label.component';
import {MCalloutComponent} from './components/molecules/m-callout/m-callout.component';
import {ATooltipComponent} from './components/atoms/a-tooltip/a-tooltip.component';
import {CapitalizePipe} from './pipes/capitalize.pipe';
import {AEnumComponent} from './components/atoms/a-enum/a-enum.component';
import {SafeHtml} from './pipes/safe-html.pipe';
import {SortableTableDirective} from './components/atoms/a-sortable/sortable-table.directive';
import {SortableColumnComponent} from './components/atoms/a-sortable/sortable-column.component';
import {ScrollToEditableDirective} from './directives/scroll-to-editable.directive';
import {APopupComponent} from './components/atoms/a-popup/a-popup.component';
import {ModalDirective} from './components/atoms/a-popup/modal.directive';
import {ScrollToTrackingLineDirective} from './directives/scroll-to-tracking-line.directive';

const components: any[] = [
    MDropdownListComponent,
    MStatsItemComponent,
    AMessageComponent,
    ATotalResultComponent,
    ATitleLabelComponent,
    ABadgeComponent,
    AUnitComponent,
    SpacerComponent,
    ABadgeComponent,
    AAvatarComponent,
    AStatusComponent,
    AGaugeBarComponent,
    AEnumComponent,
    AMentionComponent,
    AUnitLegendComponent,
    ATabComponent,
    ADatePickerComponent,
    ASpinnerComponent,
    ALabelComponent,
    MTabsComponent,
    ASpinnerComponent,
    AGaugeBarComponent,
    MStatsItemComponent,
    ALabelComponent,
    MCalloutComponent,
    APopupComponent,
    ModalDirective,
    ATooltipComponent,
    SortableColumnComponent
];

const pipes: any[] = [
    CapitalizePipe,
    SafeHtml
];

const directives: any[] = [
    SortableTableDirective,
    ScrollToEditableDirective,
    ScrollToTrackingLineDirective
];

const subModules: any = [
    UiFormsModule,
    ButtonsModule,
    LinksModule
];

@NgModule({
    declarations: [components, pipes, directives],
    imports: [
        CommonModule,
        FormsModule,
        DpDatePickerModule,
        subModules
    ],
    exports: [components, pipes, directives, subModules]
})
export class LibComponentsModule {
}
